import { useCallback } from 'react';

export interface CallLogData {
  callId: string;
  callTo: string;
  isCallAnswered: boolean;
  notes: string;
  callDate: string | Date;
  callBy: string;
}

interface UseCallLogViewReturn {
  callDate: Date;
  formatDate: (date: Date) => string;
  formatTime: (date: Date) => string;
  formatFullDate: (date: Date) => string;
}

export const useCallLogView = (callLog: CallLogData | null): UseCallLogViewReturn => {
  const callDate = callLog ? new Date(callLog.callDate) : new Date();

  const formatDate = useCallback((date: Date): string => {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }, []);

  const formatTime = useCallback((date: Date): string => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }, []);

  const formatFullDate = useCallback((date: Date): string => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }, []);

  return {
    callDate,
    formatDate,
    formatTime,
    formatFullDate
  };
};
